import * as Yup from "yup";

export const SignInSchema = Yup.object({
  numero_documento: Yup.string().required("Requerido"),
});
